import { representacionData } from '@/mocks/nosotros-data';

export default function RepresentacionInternacional() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
              Alcance global
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-4">
              {representacionData.title}
            </h2>
            <p className="text-foreground-500 text-sm md:text-base font-heading italic max-w-xl mx-auto">
              {representacionData.subtitle}
            </p>
          </div>

          {/* World Map */}
          <div className="rounded-2xl overflow-hidden bg-background-50 border border-secondary-200/60 mb-10 md:mb-14">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20elegant%20minimalist%20world%20map%20illustration%20showing%20international%20connections%20and%20network%20highlighted%20countries%20in%20warm%20red%20and%20charcoal%20tones%20clean%20modern%20design%20abstract%20global%20representation%20sophisticated%20data%20visualization%20cartographic%20art%20institutional%20aesthetic&width=1400&height=700&seq=soniem-nosotros-mapa-mundi&orientation=landscape"
                alt="Red internacional de representación recíproca SONIEM"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Description */}
          <p className="text-foreground-600 text-sm md:text-base max-w-4xl mx-auto text-center leading-relaxed mb-12 md:mb-16">
            {representacionData.description}
          </p>

          {/* Highlighted Countries */}
          <div className="mb-12 md:mb-16">
            <h4 className="text-center text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-5">
              Países con convenios de representación recíproca
            </h4>
            <div className="flex flex-wrap justify-center gap-2 md:gap-3">
              {representacionData.paisesDestacados.map((pais) => (
                <span
                  key={pais}
                  className="px-4 py-2 rounded-full bg-primary-50 text-primary-700 text-xs md:text-sm font-medium whitespace-nowrap border border-primary-100"
                >
                  {pais}
                </span>
              ))}
            </div>
          </div>

          {/* Sister Societies */}
          <div>
            <h4 className="text-center text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-6">
              Sociedades hermanas
            </h4>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {representacionData.sociedades.map((sociedad) => (
                <div
                  key={sociedad.nombre}
                  className="group rounded-xl bg-background-50 border border-secondary-200/60 p-5 text-center hover:border-primary-200/60 transition-all duration-300"
                >
                  <span className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-accent-100 text-accent-600 mb-3 group-hover:scale-110 transition-transform duration-300">
                    <i className="ri-organization-chart text-xl" />
                  </span>
                  <h5 className="font-heading text-sm font-bold text-foreground-900 mb-1">
                    {sociedad.nombre}
                  </h5>
                  <p className="text-foreground-500 text-xs leading-relaxed">
                    {sociedad.descripcion}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}